// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"64f08957","513":"f0494346","703":"c1eb853b","787":"349b0e60"}[chunkId] + ".chunk.js";
};